// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  font-family: 'Raleway', sans-serif;
}

html, body {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  height: 100%;
  background-color: rgb(250, 250, 248);
}

/* Header & Footer */
.app-bar__menu button,
.app-bar__brand h1,
.app-bar__navigation ul li a,
.skip-link,
.app-bar__navigation {
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
  padding: 10px;
}

.app-bar .app-bar__navigation {
  position: absolute;
  top: 78px;
  left: -180px;
  width: 100px;
  transition: all 0.3s;
  overflow: hidden;
}

.app-bar__navigation.open {
  left: 0;
}

.app-bar__brand h1 {
  color: rgb(255, 255, 255);
}

.restaurantsContainer h3 a {
  min-width: 44px;
  min-height: 44px;
  display: flex;
  align-items: center;
}

.restaurantsContainer h3 {
  font-size: 18px;
}


.skip-link {
  z-index: 100000;
  background-color: #aca0a0;
  color: #000000;
  position: absolute;
  padding: 5px;
  text-decoration: none;
  opacity: 0;
  left: 15%;
}

.skip-link:focus {
  opacity: 1;
}

footer {
  margin-top: auto;
  padding: 20px 0;
  background-color: rgb(44, 94, 54, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

footer p {
  color: white;
}

/* NavBar */
.app-bar {
  background-color: rgb(44, 94, 54, 0.9);
  z-index: 333;
  top: 0;
  display: grid;
  grid-template-columns: auto 1fr auto;
}

.app-bar .app-bar__menu {
  display: flex;
  align-items: center;
}

.app-bar .app-bar__menu button {
  background-color: transparent;
  border: none;
  font-size: 18px;
  padding: 20px;
  cursor: pointer;
  font-size: 30px;
}

.divider {
  border: 3px solid rgb(24, 22, 22, 0.75);
  border-radius: 4px;
  margin: 20px 0;
}

.app-bar__navigation {
  position: absolute;
  transition: all 0.3s;
  top: 75px;
  left: -180px;
  width: 150px;
  overflow: hidden;
}

ul li a {
  color: #ffffff;
  display: inline-block;
  text-decoration: none;
  padding: 10px;
}

/* Jumbotron*/
.hero {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 500px;
  width: 100%;
  position: relative;
}

.hero picture {
  height: 100%;
  width: 100%;
  position: absolute;
}

.hero picture img {
  object-fit: cover;
  height: 100%;
  width: 100%;
  position: absolute;
}

.hero__inner {
  z-index: 10;
  margin: auto 20px;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 12px;
}

.hero__title {
  font-size: 5em;
  font-weight: 800;
  padding: 0 32px;
  text-align: center;
  color: #ffffff;
}

.hero__text {
  text-align: center;
  color: #e2d7d7;
  padding-bottom: 10px;
}

.hero__tagline {
  margin-top: 16px;
  font-size: 18px;
  font-weight: 550;
  text-align: center;
}

/* Home Page */
main {
  padding: 32px;
  flex: 1;
}

.tag {
  text-align: center;
}

.titleOne {
  font-size: 1.25em;
  padding-bottom: 12px;
}

.titleTwo {
  font-size: 3em;
  padding-bottom: 12px;
}

.titleThree {
  font-size: 20px;
}

.restaurants {
  display: grid;
  grid-template-columns: repeat(3fr auto);
  gap: 16px;
}

/* card menu */
.restaurantsContainer {
  margin-top: 30px;
  border: 1px solid;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
  transition: transform 0.3s ease;
}

.restaurantsContainer:hover {
  transform: scale(1.05);
}

.restaurantsContainer img {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px 8px 0 0;
  max-width: 100%;
  max-height: 100%;
}

.restaurantsContainer p {
  margin: 10px;
}

.restaurant__name a {
  text-decoration: none;
  color: #333;
}

.restaurant__name a:hover {
  color: green;
  text-decoration: underline;
}

.restaurantsContainer .restaurant__name {
  padding: 10px;
  background-color: rgb(67, 181, 61, 0.1);
}

.restaurant {
  margin: 0 auto;
  width: 100%;
  max-width: 1200px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px 16px;
}


/* Like Button */
.like {
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(44, 94, 54, 0.9);
  position: fixed;
  bottom: 16px;
  right: 16px;
  border-radius: 50%;
  border: 0;
  font-size: 18px;
  color: white;
  cursor: pointer;
}


/* detail div */
.restaurant-detail {
  width: 90%;
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
}

.upperDiv {
  margin: 10px;
  border: 1px solid;
  border-color: black;
  border-radius: 5px;
  padding: 20px;
}

.food ul li,
.drink ul li {
  list-style: none;
  padding-top: 4px;
}

.middleCustomer {
  padding-top: 4px;
  padding-bottom: 20px;
  text-align: center;
}

.detailPictureTwo {
  border: 1px solid;
  border-color: black;
  height: auto;
  border-radius: 8px;
  max-width: 100%;
  max-height: 100%;
}


/* Agar food & drink menjadi dua column */
.menuDiv {
  display: flex;
  flex-direction: row;
}

.food,
.drink {
  flex: 1;
  padding: 20px;
  border: 1px solid;
  border-color: #000000;
  background-color: #f9f9f9;
  margin: 10px;
  border-radius: 5px;
}

/* Customer */
.customerDiv {
  border: 1px solid;
  border-color: black;
  margin: 10px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 20px;
}

.containerCustomer {
  margin-top: 10px;
  border-radius: 5px;
  width: 100%;
  max-width: 600px;
  background-color: #f9f9f9;
}

.upperNav {
  border-radius: 5px;
  border: 1px solid;
  border-color: black;
}

.borderContent {
  margin: 5px;
  padding: 10px 40px;
}

.restaurant-detail .detailPicture {
  width: 100%;
  height: 100%;
  max-width: 50%;
  max-height: 100%;
  background-size: cover;
  height: auto;
  border: 2px solid var(--color-ccc);
  border-radius: 5px;
  margin: 10px 0;
  grid-column-start: 1;
  grid-column-end: 5;
}


.upperDiv,
.food,
.drink,
.customerDiv {
  margin-top: 30px;
  border: 1px solid;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);
}

.nothing {
  font-size: 1em;
  text-align: justify;
}

.upperDiv h3{
  color: rgb(54, 151, 54);
}
.upperDiv .restName {
  font-size: 1.5em;
}

.food h3,
.drink h3,
.customerDiv h3 {
  font-size: 1.5em;
  color: rgb(54, 151, 54);
}
`, "",{"version":3,"sources":["webpack://./src/styles/style.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,SAAS;EACT,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;AACtC;;AAEA,oBAAoB;AACpB;;;;;EAKE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;;AAGA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA,WAAW;AACX;EACE,sCAAsC;EACtC,YAAY;EACZ,MAAM;EACN,aAAa;EACb,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;EACf,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,qBAAqB;EACrB,aAAa;AACf;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,OAAO;AACT;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,SAAS;AACX;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,0BAA0B;EAC1B,cAAc;AAChB;;;AAGA,gBAAgB;AAChB;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;;AAGA,eAAe;AACf;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;;AAGA,yCAAyC;AACzC;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,OAAO;EACP,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,aAAa;AACb;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,kBAAkB;AACpB;;;AAGA;;;;EAIE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":["* {\n  padding: 0;\n  margin: 0;\n  font-family: 'Raleway', sans-serif;\n}\n\nhtml, body {\n  display: flex;\n  flex-direction: column;\n  min-height: 100%;\n  height: 100%;\n  background-color: rgb(250, 250, 248);\n}\n\n/* Header & Footer */\n.app-bar__menu button,\n.app-bar__brand h1,\n.app-bar__navigation ul li a,\n.skip-link,\n.app-bar__navigation {\n  min-width: 44px;\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n  padding: 10px;\n}\n\n.app-bar .app-bar__navigation {\n  position: absolute;\n  top: 78px;\n  left: -180px;\n  width: 100px;\n  transition: all 0.3s;\n  overflow: hidden;\n}\n\n.app-bar__navigation.open {\n  left: 0;\n}\n\n.app-bar__brand h1 {\n  color: rgb(255, 255, 255);\n}\n\n.restaurantsContainer h3 a {\n  min-width: 44px;\n  min-height: 44px;\n  display: flex;\n  align-items: center;\n}\n\n.restaurantsContainer h3 {\n  font-size: 18px;\n}\n\n\n.skip-link {\n  z-index: 100000;\n  background-color: #aca0a0;\n  color: #000000;\n  position: absolute;\n  padding: 5px;\n  text-decoration: none;\n  opacity: 0;\n  left: 15%;\n}\n\n.skip-link:focus {\n  opacity: 1;\n}\n\nfooter {\n  margin-top: auto;\n  padding: 20px 0;\n  background-color: rgb(44, 94, 54, 0.9);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\nfooter p {\n  color: white;\n}\n\n/* NavBar */\n.app-bar {\n  background-color: rgb(44, 94, 54, 0.9);\n  z-index: 333;\n  top: 0;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n}\n\n.app-bar .app-bar__menu {\n  display: flex;\n  align-items: center;\n}\n\n.app-bar .app-bar__menu button {\n  background-color: transparent;\n  border: none;\n  font-size: 18px;\n  padding: 20px;\n  cursor: pointer;\n  font-size: 30px;\n}\n\n.divider {\n  border: 3px solid rgb(24, 22, 22, 0.75);\n  border-radius: 4px;\n  margin: 20px 0;\n}\n\n.app-bar__navigation {\n  position: absolute;\n  transition: all 0.3s;\n  top: 75px;\n  left: -180px;\n  width: 150px;\n  overflow: hidden;\n}\n\nul li a {\n  color: #ffffff;\n  display: inline-block;\n  text-decoration: none;\n  padding: 10px;\n}\n\n/* Jumbotron*/\n.hero {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 500px;\n  width: 100%;\n  position: relative;\n}\n\n.hero picture {\n  height: 100%;\n  width: 100%;\n  position: absolute;\n}\n\n.hero picture img {\n  object-fit: cover;\n  height: 100%;\n  width: 100%;\n  position: absolute;\n}\n\n.hero__inner {\n  z-index: 10;\n  margin: auto 20px;\n  background-color: rgba(0, 0, 0, 0.2);\n  border-radius: 12px;\n}\n\n.hero__title {\n  font-size: 5em;\n  font-weight: 800;\n  padding: 0 32px;\n  text-align: center;\n  color: #ffffff;\n}\n\n.hero__text {\n  text-align: center;\n  color: #e2d7d7;\n  padding-bottom: 10px;\n}\n\n.hero__tagline {\n  margin-top: 16px;\n  font-size: 18px;\n  font-weight: 550;\n  text-align: center;\n}\n\n/* Home Page */\nmain {\n  padding: 32px;\n  flex: 1;\n}\n\n.tag {\n  text-align: center;\n}\n\n.titleOne {\n  font-size: 1.25em;\n  padding-bottom: 12px;\n}\n\n.titleTwo {\n  font-size: 3em;\n  padding-bottom: 12px;\n}\n\n.titleThree {\n  font-size: 20px;\n}\n\n.restaurants {\n  display: grid;\n  grid-template-columns: repeat(3fr auto);\n  gap: 16px;\n}\n\n/* card menu */\n.restaurantsContainer {\n  margin-top: 30px;\n  border: 1px solid;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);\n  transition: transform 0.3s ease;\n}\n\n.restaurantsContainer:hover {\n  transform: scale(1.05);\n}\n\n.restaurantsContainer img {\n  width: 100%;\n  height: 150px;\n  object-fit: cover;\n  border-radius: 8px 8px 0 0;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.restaurantsContainer p {\n  margin: 10px;\n}\n\n.restaurant__name a {\n  text-decoration: none;\n  color: #333;\n}\n\n.restaurant__name a:hover {\n  color: green;\n  text-decoration: underline;\n}\n\n.restaurantsContainer .restaurant__name {\n  padding: 10px;\n  background-color: rgb(67, 181, 61, 0.1);\n}\n\n.restaurant {\n  margin: 0 auto;\n  width: 100%;\n  max-width: 1200px;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 18px 16px;\n}\n\n\n/* Like Button */\n.like {\n  width: 55px;\n  height: 55px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgb(44, 94, 54, 0.9);\n  position: fixed;\n  bottom: 16px;\n  right: 16px;\n  border-radius: 50%;\n  border: 0;\n  font-size: 18px;\n  color: white;\n  cursor: pointer;\n}\n\n\n/* detail div */\n.restaurant-detail {\n  width: 90%;\n  max-width: 800px;\n  margin: 20px auto;\n  padding: 20px;\n}\n\n.upperDiv {\n  margin: 10px;\n  border: 1px solid;\n  border-color: black;\n  border-radius: 5px;\n  padding: 20px;\n}\n\n.food ul li,\n.drink ul li {\n  list-style: none;\n  padding-top: 4px;\n}\n\n.middleCustomer {\n  padding-top: 4px;\n  padding-bottom: 20px;\n  text-align: center;\n}\n\n.detailPictureTwo {\n  border: 1px solid;\n  border-color: black;\n  height: auto;\n  border-radius: 8px;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n\n/* Agar food & drink menjadi dua column */\n.menuDiv {\n  display: flex;\n  flex-direction: row;\n}\n\n.food,\n.drink {\n  flex: 1;\n  padding: 20px;\n  border: 1px solid;\n  border-color: #000000;\n  background-color: #f9f9f9;\n  margin: 10px;\n  border-radius: 5px;\n}\n\n/* Customer */\n.customerDiv {\n  border: 1px solid;\n  border-color: black;\n  margin: 10px;\n  border-radius: 5px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  padding: 20px;\n}\n\n.containerCustomer {\n  margin-top: 10px;\n  border-radius: 5px;\n  width: 100%;\n  max-width: 600px;\n  background-color: #f9f9f9;\n}\n\n.upperNav {\n  border-radius: 5px;\n  border: 1px solid;\n  border-color: black;\n}\n\n.borderContent {\n  margin: 5px;\n  padding: 10px 40px;\n}\n\n.restaurant-detail .detailPicture {\n  width: 100%;\n  height: 100%;\n  max-width: 50%;\n  max-height: 100%;\n  background-size: cover;\n  height: auto;\n  border: 2px solid var(--color-ccc);\n  border-radius: 5px;\n  margin: 10px 0;\n  grid-column-start: 1;\n  grid-column-end: 5;\n}\n\n\n.upperDiv,\n.food,\n.drink,\n.customerDiv {\n  margin-top: 30px;\n  border: 1px solid;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.25);\n}\n\n.nothing {\n  font-size: 1em;\n  text-align: justify;\n}\n\n.upperDiv h3{\n  color: rgb(54, 151, 54);\n}\n.upperDiv .restName {\n  font-size: 1.5em;\n}\n\n.food h3,\n.drink h3,\n.customerDiv h3 {\n  font-size: 1.5em;\n  color: rgb(54, 151, 54);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
